import { useTellescopeQuery } from "@tellescope/tanstack-query";

export interface StripeInvoiceLineItem {
  description: string;
  amount: number; // cents
  period: {
    start: number; // Unix seconds
    end: number; // Unix seconds
  };
}

export interface StripeInvoiceCharge {
  status: string;
  receipt_url?: string;
  payment_method_details?: {
    card?: {
      brand: string;
      last4: string;
    };
  };
}

export interface StripeInvoice {
  id: string;
  number: string;
  status: "paid" | "open" | "draft" | "void" | "uncollectible";
  created: number; // Unix seconds
  currency: string;
  amount_due: number; // cents
  amount_paid: number; // cents
  amount_remaining: number; // cents
  invoice_pdf: string | null;
  hosted_invoice_url: string | null;
  lines: { data: StripeInvoiceLineItem[] };
  charge?: StripeInvoiceCharge | null;
}

export interface StripeInvoicesResponse {
  invoices: StripeInvoice[];
}

export const useStripeInvoices = () => {
  const query = useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: {
      integration: "Stripe",
      type: "invoices",
    },
    staleTime: 5 * 60 * 1000,
    select: (response): StripeInvoicesResponse => response?.data ?? { invoices: [] },
  });

  const invoices = Array.isArray(query.data?.invoices) ? query.data.invoices : [];

  return {
    ...query,
    invoices,
  };
};
